import React, { Component } from "react";
import store from "../state/store";
// import "../../scss/varsome-style.scss";

export default class Toaster extends Component {
  constructor() {
    super();
    this.state = {
      toasts: [],
    };
  }

  componentDidMount() {
    store.subscribe(() => {
      // If we receive a toast, add it to component's internal state
      // and clear it from global store
      const { toast } = store.getState();
      if (toast) {
        this.addToast(toast);
        store.dispatch({
          type: "CLEAR_TOAST",
        });
      }
    });

    // Checking every second and removing expired toasts
    setInterval(() => {
      const { toasts } = this.state;
      for (let i = toasts.length - 1; i >= 0; i--) {
        const toast = toasts[i];
        // Check if permanent toast
        if (toast.duration !== -1) {
          toast.duration -= 1000;
          if (toast.duration < 0) {
            toasts.splice(i, 1);
          }
        }
      }
      this.setState({ toasts });
    }, 1000);
  }

  removeToast(idx) {
    const { toasts } = this.state;
    toasts.splice(idx, 1);
    this.setState(toasts);
  }

  addToast(toast) {
    toast.addedAt = new Date().getTime();
    const { toasts } = this.state;
    toasts.push(toast);
    this.setState({ toasts });
  }

  render() {
    const { toasts } = this.state;
    return (
      <div className="toast-container">
        {toasts.map((toast, i) => {
          return (
            <div className="toast" key={toast.addedAt}>
              {toast.importance === "info" ? (
                <i className="fa fa-info-circle" />
              ) : null}
              {toast.importance === "failure" ? (
                <i className="fa fa-exclamation-circle" />
              ) : null}
              {toast.importance === "success" ? (
                <i className="fa fa-check" />
              ) : null}
              {toast.text}
              <span
                className="closeBtn"
                onClick={() => {
                  this.removeToast(i);
                }}
              >
                <i className="varsome-icons icon-cancel-circle" />
              </span>
            </div>
          );
        })}
      </div>
    );
  }
}
